(() => {
  const initializeNavigation = (navigation) => {
    if (!(navigation instanceof HTMLElement) || navigation.dataset.scrollCueReady === 'true') return;

    const track = navigation.querySelector('[data-category-navigation-track]');
    const nextButton = navigation.querySelector('[data-category-navigation-next]');
    if (!(track instanceof HTMLElement) || !(nextButton instanceof HTMLButtonElement)) return;

    navigation.dataset.scrollCueReady = 'true';

    const updateCue = () => {
      const hasOverflow = track.scrollWidth > track.clientWidth + 2;
      const isAtEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
      const hasNext = hasOverflow && !isAtEnd;

      navigation.classList.toggle('has-next', hasNext);
      nextButton.hidden = !hasNext;
    };

    nextButton.addEventListener('click', () => {
      track.scrollBy({
        left: Math.max(track.clientWidth * 0.72, 180),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    });

    track.addEventListener('scroll', updateCue, { passive: true });
    new ResizeObserver(updateCue).observe(track);
    updateCue();
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-category-navigation]').forEach(initializeNavigation);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
